export default (file, extension) => {
  const fileExtension = file.split('.').pop();
  return extension.includes(fileExtension);
};
